import * as React from 'react';
import PageFooter from '../partials/PageFooter';
import styles from './ErrorPage.module.less';
import { IconVariation, T } from '@testout/labsim-ui-atomics';
export default class ErrorPage extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (React.createElement("div", { className: styles.container },
            React.createElement("div", { className: styles.content },
                React.createElement(T.Text.H1, { automationId: 'title', variation: T.Text.Variation.H1_Large, className: styles.errorTitle }, "Oops! Something went wrong."),
                React.createElement(T.InfoBox, { automationId: 'loggedInMesssage', className: styles.loggedIn },
                    React.createElement(T.InfoBox.Body, { variation: T.InfoBox.Variation.Custom, iconVariation: T.IconVariation.InfoCircle }, "You are currently logged in.")),
                React.createElement(T.InfoBox, { automationId: 'errorMessage', className: styles.error },
                    React.createElement(T.InfoBox.Body, { variation: T.InfoBox.Variation.Custom, iconVariation: T.IconVariation.Warning }, this.props.errorMsg || '')),
                React.createElement(T.Text.P, { automationId: 'contactPlease' }, `${this.props.failedAction || ''} Please contact support for assistance.`.trim()),
                React.createElement("div", { className: styles.supportLinks },
                    React.createElement(T.Link, { automationId: 'supportLink', href: 'https://www.comptia.org/contact-us', target: '_blank' },
                        React.createElement(T.Icon, { automationId: 'supportLink-icon', variation: IconVariation.Desktop }),
                        "Support"),
                    React.createElement(T.Link, { automationId: 'guideLink', href: 'https://help.comptia.org/hc/en-us/sections/15483943055252-LMS-Integration-2024', target: '_blank' },
                        React.createElement(T.Icon, { automationId: 'guideLink-icon', variation: 'clipboard-list' }),
                        "Integration Guide"))),
            React.createElement(PageFooter, null)));
    }
}
//# sourceMappingURL=ErrorPage.js.map